import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import dayjs from "dayjs";
const CDate = ({ date }) => {
    if (date) {
        return _jsx(_Fragment, { children: dayjs(date).format("L") });
    }
    return _jsx("span", { children: "N/A" });
};
const CTime = ({ date }) => {
    if (date) {
        return _jsx(_Fragment, { children: dayjs(date).format("LT") });
    }
    return _jsx("span", {});
};
export { CDate, CTime };
